import Vue from 'vue'
import Router from 'vue-router'
import admin from '@/view/admin.vue'
import {getCookie} from '@/utils/support';
let company_id =  getCookie('company_id');

Vue.use(Router)


export const routes = [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login.vue'),
      meta: {title: '登录',keepAlive: false,noMenu:true},
    },
    {
      path: '',
      component: admin,
      redirect: '/home',
      activePath:'home',
      noChildren:false,
      meta: {title: '首页',keepAlive: false,noMenu:true},
      children: [{
        path: 'home',
        name: 'home',
        component: () => import('@/view/home/index.vue'),
      },],
    },
    {
    	path: '/customer',
    	name: 'customer',
      activePath:'customer',
      component: admin,
      redirect: '/customer/customerCP',
      noChildren:false,
      meta: {title: '客户'},
      children:[
        {
          path: 'customerCP',
          name: 'customerCP',
          component: () => import('@/view/customer/customerCP/index.vue'),
          meta: {title: '我的客户',sideBar:true,keepAlive: true},
        },
        {
          path: 'customerDetail',
          name: 'customerDetail',
          component: () => import('@/view/customer/customerCP/customerDetail.vue'),
          meta: {title: '客户详细信息',keepAlive: false},
          hidden:true
        },
        {
          path: 'customerInput',
          name: 'customerInput',
          component: () => import('@/view/customer/customerCP/customerInput.vue'),
          meta: {title: '客户信息录入',keepAlive: false},
          hidden:true
        },
        {
          path: 'c_addressBook',
          name: 'c_addressBook',
          component: () => import('@/view/customer/customerCP/c_addressBook.vue'),
          meta: {title: '通讯录',keepAlive: false},
          hidden:true
        },
        {
          path: 'c_memorandum',
          name: 'c_memorandum',
          component: () => import('@/view/customer/customerCP/c_memorandum.vue'),
          meta: {title: '备忘录',keepAlive: false},
          hidden:true
        },
        {
          path: 'companyPersonnel',
          name: 'companyPersonnel',
          component: () => import('@/view/customer/customerCP/companyPersonnel.vue'),
          meta: {title: '公司人员',keepAlive: false},
          hidden:true
        },
        {
          path: 'account',
          name: 'account',
          component: () => import('@/view/customer/customerCP/account.vue'),
          meta: {title: '账号管理',keepAlive: false},
          hidden:true
        },
        {
          path: 'points',
          name: 'points',
          component: () => import('@/view/customer/customerCP/points.vue'),
          meta: {title: '积分管理',keepAlive: false},
          hidden:true
        },
        {
          path: 'bankAccount',
          name: 'bankAccount',
          component: () => import('@/view/customer/customerCP/bankAccount.vue'),
          meta: {title: '银行账户',keepAlive: false},
          hidden:true
        },
        {
          path: 'shoppingCart',
          name: 'shoppingCart',
          component: () => import('@/view/customer/customerCP/shoppingCart.vue'),
          meta: {title: '购物车',keepAlive: false},
          hidden:true
        },
        {
          path: 'favorites',
          name: 'favorites',
          component: () => import('@/view/customer/customerCP/favorites.vue'),
          meta: {title: '收藏夹',keepAlive: false},
          hidden:true
        },
        {
          path: 'personnelDetail',
          name: 'personnelDetail',
          component: () => import('@/view/customer/customerCP/personnelDetail.vue'),
          meta: {title: '公司人员信息',keepAlive: false},
          hidden:true
        },
        {
          path: 'personnelAddEdit',
          name: 'personnelAddEdit',
          component: () => import('@/view/customer/customerCP/personnelAddEdit.vue'),
          meta: {title: '公司人员',keepAlive: false},
          hidden:true
        },
        {
          path: 'accountAddEdit',
          name: 'accountAddEdit',
          component: () => import('@/view/customer/customerCP/accountAddEdit.vue'),
          meta: {title: '公司账号',keepAlive: false},
          hidden:true
        },
        {
          path: 'pointsEdit',
          name: 'pointsEdit',
          component: () => import('@/view/customer/customerCP/pointsEdit.vue'),
          meta: {title: '积分订单编辑',keepAlive: false},
          hidden:true
        },
        {
          path: 'bankAddEdit',
          name: 'bankAddEdit',
          component: () => import('@/view/customer/customerCP/bankAddEdit.vue'),
          meta: {title: '银行账号编辑',keepAlive: false},
          hidden:true
        },
        {
          path: 'relatedBusiness',
          name: 'relatedBusiness',
          component: () => import('@/view/customer/customerCP/relatedBusiness.vue'),
          meta: {title: '业务关联客户管理',keepAlive: false},
          hidden:true
        },
        {
          path: 'rebate',
          name: 'rebate',
          component: () => import('@/view/customer/customerCP/rebate.vue'),
          meta: {title: '扶商返利',keepAlive: false},
          hidden:true
        },
        {
          path: 'minutesOfTalks',
          name: 'minutesOfTalks',
          component: () => import('@/view/customer/customerCP/minutesOfTalks.vue'),
          meta: {title: '客户重要会谈纪要',keepAlive: false},
          hidden:true
        },
        {
          path: 'minutesOfTalksDetail',
          name: 'minutesOfTalksDetail',
          component: () => import('@/view/customer/customerCP/minutesOfTalksDetail.vue'),
          meta: {title: '查看客户重要会谈纪要',keepAlive: false},
          hidden:true
        },
        {
          path: 'minutesOfTalksEdit',
          name: 'minutesOfTalksEdit',
          component: () => import('@/view/customer/customerCP/minutesOfTalksEdit.vue'),
          meta: {title: '客户重要会谈纪要编辑',keepAlive: false},
          hidden:true
        },
        {
          path: 'memorabilia',
          name: 'memorabilia',
          component: () => import('@/view/customer/customerCP/memorabilia.vue'),
          meta: {title: '合作大事记',keepAlive: false},
          hidden:true
        },
        {
          path: 'memorabiliaDetail',
          name: 'memorabiliaDetail',
          component: () => import('@/view/customer/customerCP/memorabiliaDetail.vue'),
          meta: {title: '查看合作大事记',keepAlive: false},
          hidden:true
        },
        {
          path: 'memorabiliaEdit',
          name: 'memorabiliaEdit',
          component: () => import('@/view/customer/customerCP/memorabiliaEdit.vue'),
          meta: {title: '合作大事记编辑',keepAlive: false},
          hidden:true
        },
        {
          path: 'statementOfAccount',
          name: 'statementOfAccount',
          component: () => import('@/view/customer/customerCP/statementOfAccount.vue'),
          meta: {title: '客户对账单',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/product',
    	name: 'product',
      activePath:'product',
      component: admin,
      redirect: '/product/productCP',
      noChildren:false,
      meta: {title: '产品'},
      children:[
        {
          path: 'productCP',
          name: 'productCP',
          component: () => import('@/view/product/productCP/index.vue'),
          meta: {title: 'TiBao产品',sideBar:true,keepAlive: true},
        },
        {
          path: 'productDetail',
          name: 'productDetail',
          component: () => import('@/view/product/productCP/productDetail.vue'),
          meta: {title: '产品详情',keepAlive: false},
          hidden:true
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('@/view/product/productCP/feedback.vue'),
          meta: {title: '相关问题',keepAlive: false},
          hidden:true
        },
        {
          path: 'VINDetails',
          name: 'VINDetails',
          component: () => import('@/view/product/productCP/VINDetails.vue'),
          meta: {title: 'VIN结果',keepAlive: false},
          hidden:true
        },
        {
          path: 'productDetailEdit',
          name: 'productDetailEdit',
          component: () => import('@/view/product/productCP/productDetailEdit.vue'),
          meta: {title: '产品信息录入',keepAlive: false},
          hidden:true
        },
        {
          path: 'productModel',
          name: 'productModel',
          component: () => import('@/view/product/productCP/productModel.vue'),
          meta: {title: '车型信息',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/select',
    	name: 'select',
      activePath:'select',
      component: admin,
      redirect: '/select/cart',
      noChildren:false,
      meta: {title: '购物车'},
      children:[
        {
          path: 'cart',
          name: 'cart',
          component: () => import('@/view/select/cart/index.vue'),
          meta: {title: '购物车',sideBar:true,keepAlive: true},
        },
      ],
    },
    {
    	path: '/bills',
    	name: 'bills',
      activePath:'bills',
      component: admin,
      noChildren:false,
      redirect: '/bills/billsCP',
      meta: {title: '订单'},
      children:[
        {
          path: 'billsCP',
          name: 'billsCP',
          component: () => import('@/view/bills/billsCP/order.vue'),
          meta: {title: '订单',sideBar:true,keepAlive: true},
        },
        {
          path: 'generateOrderDetail',
          name: 'generateOrderDetail',
          component: () => import('@/view/bills/billsCP/generateOrderDetail.vue'),
          meta: {title: '订单详情',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/newPrice',
    	// name: 'newPrice',
      activePath:'newPrice',
      component: admin,
      redirect: '/product/newPrice',
      noChildren:false,
      meta: {title: '销售定价'},
      children:[
        {
          path: '/product/newPrice',
          name: 'newPrice',
          component: () => import('@/view/product/productCP/newPrice.vue'),
          meta: {title: '',sideBar:false,keepAlive: true},
        },
      ],
    },
    {
    	path: '/orderStock',
      activePath:'orderStock',
      component: admin,
      redirect: '/bills/orderStock',
      noChildren:false,
      meta: {title: '客户库存订单'},
      children:[
        {
          path: '/bills/orderStock',
          name: 'orderStock',
          component: () => import('@/view/bills/billsCP/orderStock.vue'),
          meta: {title: '客户库存订单',sideBar:true,keepAlive: true},
        }
      ],
    },
    {
    	path: '/orderCancelStockSummary',
      activePath:'orderCancelStockSummary',
      component: admin,
      redirect: '/bills/orderCancelStockSummary',
      noChildren:true,
      meta: {title: '订单取消库存汇总'},
      children:[
        {
          path: '/bills/orderCancelStockSummary',
          name: 'orderCancelStockSummary',
          component: () => import('@/view/bills/billsCP/orderCancelStockSummary.vue'),
          meta: {title: '订单取消库存汇总',sideBar:false,keepAlive: true},
        }
      ],
    },
    // {
    //   path: '/pack/generatePackOrder',
    //   name: 'generatePackOrder',
    //   component: () => import('@/view/pack/packCP/generatePackOrder.vue'),
    //   meta: {title: '打包单',keepAlive: false,noMenu:true},
    //   hidden:true
    // },
    {
    	path: '/pack',
    	name: 'pack',
      activePath:'pack',
      component: admin,
      redirect: '/pack/generatePackOrder',
      noChildren:false,
      meta: {title: '打包单',noMenu:true},
      children:[
        {
          path: 'generatePackOrder',
          name: 'generatePackOrder',
          component: () => import('@/view/pack/packCP/generatePackOrder.vue'),
          meta: {title: '打包单',keepAlive: false},
          hidden:true
        },
      ],
    },
    {
    	path: '/packing',
      activePath:'packing',
      component: admin,
      redirect: '/packingCp/packing',
      noChildren:false,
      meta: {title: '装箱单',noMenu:true},
      children:[
        {
          path: '/packingCp/packing',
          name: 'packing',
          component: () => import('@/view/other/packingCp/packing.vue'),
          meta: {title: '装箱单',keepAlive: false},
          hidden:true
        },
      ],
    },
    // {
    // 	path: '/pack',
    // 	name: 'pack',
    //   activePath:'pack',
    //   component: admin,
    //   redirect: '/pack/generatePackOrder',
    //   noChildren:false,
    //   meta: {title: '打包(发货)'},
    //   children:[
    //     {
    //       path: 'packCP',
    //       name: 'packCP',
    //       component: () => import('@/view/pack/packCP/pack.vue'),
    //       meta: {title: '打包(发货)',sideBar:true,keepAlive: false},
    //     },
    //     {
    //       path: 'g_AddEditPackOrder',
    //       name: 'g_AddEditPackOrder',
    //       component: () => import('@/view/pack/packCP/g_AddEditPackOrder.vue'),
    //       meta: {title: '打包(发货)详情',keepAlive: false},
    //       hidden:true
    //     },
    //     {
    //       path: 'generatePackOrder',
    //       name: 'generatePackOrder',
    //       component: () => import('@/view/pack/packCP/generatePackOrder.vue'),
    //       meta: {title: '其他打包(发货)',keepAlive: false},
    //       hidden:true
    //     },
    //   ],
    // },
  ]


export const routes2 = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/view/login.vue'),
    meta: {title: '登录',keepAlive: false,noMenu:true},
  },
  {
    path: '',
    component: admin,
    redirect: '/home',
    activePath:'home',
    noChildren:false,
    meta: {title: '首页',keepAlive: false,noMenu:true},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/view/home/index.vue'),
    },],
  },
  {
    path: '/quotedPriceOrder',
    name: 'quotedPriceOrder',
    component: () => import('@/view/other/quotedPrice/quotedPriceCP/quotedPriceOrder.vue'),
    meta: {title: '报价单详情',keepAlive: false,noMenu:true},
  },
  {
    path: '/customer',
    name: 'customer',
    activePath:'customer',
    component: admin,
    redirect: '/customer/customerCP',
    noChildren:false,
    meta: {title: '客户'},
    children:[
      {
        path: 'customerCP',
        name: 'customerCP',
        component: () => import('@/view/customer/customerCP/index.vue'),
        meta: {title: '我的客户',sideBar:true,keepAlive: true},
      },
      {
        path: 'customerDetail',
        name: 'customerDetail',
        component: () => import('@/view/customer/customerCP/customerDetail.vue'),
        meta: {title: '客户详细信息',keepAlive: false},
        hidden:true
      },
      {
        path: 'customerInput',
        name: 'customerInput',
        component: () => import('@/view/customer/customerCP/customerInput.vue'),
        meta: {title: '客户信息录入',keepAlive: false},
        hidden:true
      },
      {
        path: 'c_addressBook',
        name: 'c_addressBook',
        component: () => import('@/view/customer/customerCP/c_addressBook.vue'),
        meta: {title: '通讯录',keepAlive: false},
        hidden:true
      },
      {
        path: 'c_memorandum',
        name: 'c_memorandum',
        component: () => import('@/view/customer/customerCP/c_memorandum.vue'),
        meta: {title: '备忘录',keepAlive: false},
        hidden:true
      },
      {
        path: 'companyPersonnel',
        name: 'companyPersonnel',
        component: () => import('@/view/customer/customerCP/companyPersonnel.vue'),
        meta: {title: '公司人员',keepAlive: false},
        hidden:true
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('@/view/customer/customerCP/account.vue'),
        meta: {title: '账号管理',keepAlive: false},
        hidden:true
      },
      {
        path: 'points',
        name: 'points',
        component: () => import('@/view/customer/customerCP/points.vue'),
        meta: {title: '积分管理',keepAlive: false},
        hidden:true
      },
      {
        path: 'bankAccount',
        name: 'bankAccount',
        component: () => import('@/view/customer/customerCP/bankAccount.vue'),
        meta: {title: '银行账户',keepAlive: false},
        hidden:true
      },
      {
        path: 'shoppingCart',
        name: 'shoppingCart',
        component: () => import('@/view/customer/customerCP/shoppingCart.vue'),
        meta: {title: '购物车',keepAlive: false},
        hidden:true
      },
      {
        path: 'favorites',
        name: 'favorites',
        component: () => import('@/view/customer/customerCP/favorites.vue'),
        meta: {title: '收藏夹',keepAlive: false},
        hidden:true
      },
      {
        path: 'personnelDetail',
        name: 'personnelDetail',
        component: () => import('@/view/customer/customerCP/personnelDetail.vue'),
        meta: {title: '公司人员信息',keepAlive: false},
        hidden:true
      },
      {
        path: 'personnelAddEdit',
        name: 'personnelAddEdit',
        component: () => import('@/view/customer/customerCP/personnelAddEdit.vue'),
        meta: {title: '公司人员',keepAlive: false},
        hidden:true
      },
      {
        path: 'accountAddEdit',
        name: 'accountAddEdit',
        component: () => import('@/view/customer/customerCP/accountAddEdit.vue'),
        meta: {title: '公司账号',keepAlive: false},
        hidden:true
      },
      {
        path: 'pointsEdit',
        name: 'pointsEdit',
        component: () => import('@/view/customer/customerCP/pointsEdit.vue'),
        meta: {title: '积分订单编辑',keepAlive: false},
        hidden:true
      },
      {
        path: 'bankAddEdit',
        name: 'bankAddEdit',
        component: () => import('@/view/customer/customerCP/bankAddEdit.vue'),
        meta: {title: '银行账号编辑',keepAlive: false},
        hidden:true
      },
      {
        path: 'relatedBusiness',
        name: 'relatedBusiness',
        component: () => import('@/view/customer/customerCP/relatedBusiness.vue'),
        meta: {title: '业务关联客户管理',keepAlive: false},
        hidden:true
      },
      {
        path: 'rebate',
        name: 'rebate',
        component: () => import('@/view/customer/customerCP/rebate.vue'),
        meta: {title: '扶商返利',keepAlive: false},
        hidden:true
      },
      {
        path: 'minutesOfTalks',
        name: 'minutesOfTalks',
        component: () => import('@/view/customer/customerCP/minutesOfTalks.vue'),
        meta: {title: '客户重要会谈纪要',keepAlive: false},
        hidden:true
      },
      {
        path: 'minutesOfTalksDetail',
        name: 'minutesOfTalksDetail',
        component: () => import('@/view/customer/customerCP/minutesOfTalksDetail.vue'),
        meta: {title: '查看客户重要会谈纪要',keepAlive: false},
        hidden:true
      },
      {
        path: 'minutesOfTalksEdit',
        name: 'minutesOfTalksEdit',
        component: () => import('@/view/customer/customerCP/minutesOfTalksEdit.vue'),
        meta: {title: '客户重要会谈纪要编辑',keepAlive: false},
        hidden:true
      },
      {
        path: 'memorabilia',
        name: 'memorabilia',
        component: () => import('@/view/customer/customerCP/memorabilia.vue'),
        meta: {title: '合作大事记',keepAlive: false},
        hidden:true
      },
      {
        path: 'memorabiliaDetail',
        name: 'memorabiliaDetail',
        component: () => import('@/view/customer/customerCP/memorabiliaDetail.vue'),
        meta: {title: '查看合作大事记',keepAlive: false},
        hidden:true
      },
      {
        path: 'memorabiliaEdit',
        name: 'memorabiliaEdit',
        component: () => import('@/view/customer/customerCP/memorabiliaEdit.vue'),
        meta: {title: '合作大事记编辑',keepAlive: false},
        hidden:true
      },
      {
        path: 'statementOfAccount',
        name: 'statementOfAccount',
        component: () => import('@/view/customer/customerCP/statementOfAccount.vue'),
        meta: {title: '客户对账单',keepAlive: false},
        hidden:true
      },
    ],
  },
  {
    path: '/product',
    name: 'product',
    activePath:'product',
    component: admin,
    redirect: '/product/productCP',
    noChildren:false,
    meta: {title: '产品'},
    children:[
      {
        path: 'productCP',
        name: 'productCP',
        component: () => import('@/view/product/productCP/index.vue'),
        meta: {title: 'TiBao产品',sideBar:true,keepAlive: true},
      },
      {
        path: 'productDetail',
        name: 'productDetail',
        component: () => import('@/view/product/productCP/productDetail.vue'),
        meta: {title: '产品详情',keepAlive: false},
        hidden:true
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('@/view/product/productCP/feedback.vue'),
        meta: {title: '相关问题',keepAlive: false},
        hidden:true
      },
      {
        path: 'VINDetails',
        name: 'VINDetails',
        component: () => import('@/view/product/productCP/VINDetails.vue'),
        meta: {title: 'VIN结果',keepAlive: false},
        hidden:true
      },
      {
        path: 'productDetailEdit',
        name: 'productDetailEdit',
        component: () => import('@/view/product/productCP/productDetailEdit.vue'),
        meta: {title: '产品信息录入',keepAlive: false},
        hidden:true
      },
      {
        path: 'productModel',
        name: 'productModel',
        component: () => import('@/view/product/productCP/productModel.vue'),
        meta: {title: '适用车型',keepAlive: false},
        hidden:true
      },
    ],
  },
  {
    path: '/select',
    name: 'select',
    activePath:'select',
    component: admin,
    redirect: '/select/cart',
    noChildren:false,
    meta: {title: '购物车'},
    children:[
      {
        path: 'cart',
        name: 'cart',
        component: () => import('@/view/select/cart/index.vue'),
        meta: {title: '购物车',sideBar:true,keepAlive: true},
      },
    ],
  },
  {
    path: '/quotedPrice',
    name: 'quotedPrice',
    activePath:'quotedPrice',
    component: admin,
    redirect: '/quotedPrice/quotedPriceCP',
    noChildren:false,
    meta: {title: '报价'},
    children:[
      {
        path: '/quotedPrice/quotedPriceCP',
        name: 'quotedPriceCP',
        component: () => import('@/view/other/quotedPrice/quotedPriceCP/index.vue'),
        meta: {title: '报价',sideBar:true,keepAlive: true},
      },
      {
        path: '/quotedPrice/generateQuotedPriceOrder',
        name: 'generateQuotedPriceOrder',
        component: () => import('@/view/other/quotedPrice/quotedPriceCP/generateQuotedPriceOrder.vue'),
        meta: {title: '报价单详情',keepAlive: false},
        hidden:true
      },
    ],
  },
  {
    path: '/bills',
    name: 'bills',
    activePath:'bills',
    component: admin,
    noChildren:false,
    redirect: '/bills/billsCP',
    meta: {title: '订单'},
    children:[
      {
        path: 'billsCP',
        name: 'billsCP',
        component: () => import('@/view/bills/billsCP/order.vue'),
        meta: {title: '订单',sideBar:true,keepAlive: true},
      },
      {
        path: 'generateOrderDetail',
        name: 'generateOrderDetail',
        component: () => import('@/view/bills/billsCP/generateOrderDetail.vue'),
        meta: {title: '订单详情',keepAlive: false},
        hidden:true
      },
    ],
  },
  {
    path: '/Orderchange',
    name: 'Orderchange',
    activePath:'orderChangeList',
    component: admin,
    noChildren:false,
    redirect: '/bills/orderChangeList',
    meta: {title: '订单变更'},
    children:[
      {
        path: '/bills/orderChangeList',
        name: 'orderChangeList',
        component: () => import('@/view/bills/billsCP/orderChangeList.vue'),
        meta: {title: '订单变更单列表',sideBar:true,keepAlive: true},
      },
      {
        path: '/bills/orderChange',
        name: 'orderChange',
        component: () => import('@/view/bills/billsCP/orderChange.vue'),
        meta: {title: '销售订单变更单详情',keepAlive: false},
        hidden:true
      },
    ],
  },
  {
  	path: '/pack',
  	name: 'pack',
    activePath:'pack',
    component: admin,
    redirect: '/pack/generatePackOrder',
    noChildren:false,
    meta: {title: '打包单',noMenu:true},
    children:[
      {
        path: 'generatePackOrder',
        name: 'generatePackOrder',
        component: () => import('@/view/pack/packCP/generatePackOrder.vue'),
        meta: {title: '打包单',keepAlive: false},
        hidden:true
      },
    ],
  },
  // {
  // 	path: '/pack',
  // 	name: 'pack',
  //   activePath:'pack',
  //   component: admin,
  //   redirect: '/pack/packCP',
  //   noChildren:false,
  //   meta: {title: '打包(发货)'},
  //   children:[
  //     {
  //       path: 'packCP',
  //       name: 'packCP',
  //       component: () => import('@/view/pack/packCP/pack.vue'),
  //       meta: {title: '打包(发货)',sideBar:true,keepAlive: false},
  //     },
  //     {
  //       path: 'g_AddEditPackOrder',
  //       name: 'g_AddEditPackOrder',
  //       component: () => import('@/view/pack/packCP/g_AddEditPackOrder.vue'),
  //       meta: {title: '打包(发货)详情',keepAlive: false},
  //       hidden:true
  //     },
  //     {
  //       path: 'generatePackOrder',
  //       name: 'generatePackOrder',
  //       component: () => import('@/view/pack/packCP/generatePackOrder.vue'),
  //       meta: {title: '其他打包(发货)',keepAlive: false},
  //       hidden:true
  //     },
  //   ],
  // },
  // {
  // 	path: '/packing',
  // 	name: 'packing',
  //   activePath:'packing',
  //   component: admin,
  //   redirect: '/packingCp/packing',
  //   noChildren:false,
  //   meta: {title: '装箱单'},
  //   children:[
  //     {
  //       path: '/packingCp/packing',
  //       name: 'packing',
  //       component: () => import('@/view/other/packingCp/packing.vue'),
  //       meta: {title: '装箱单',sideBar:true,keepAlive: true},
  //     },
  //   ],
  // },
  {
    path: '/other',
    name: 'other',
    activePath:'other',
    component: admin,
    redirect: '/bills/orderReview',
    noChildren:true,
    meta: {title: '其他'},
    children:[
      {
        path: '/bills/orderReview',
        name: 'orderReview',
        component: () => import('@/view/bills/billsCP/orderReview.vue'),
        meta: {title: '订单评审',sideBar:false,keepAlive: true},
      },
      {
        path: '/bills/shipmentPlan',
        name: 'shipmentPlan',
        component: () => import('@/view/bills/billsCP/shipmentPlan.vue'),
        meta: {title: '出运计划单',keepAlive: false},
      },
      {
        path: '/bills/orderFollow',
        name: 'orderFollow',
        component: () => import('@/view/bills/billsCP/orderFollow.vue'),
        meta: {title: '订单执行跟进',keepAlive: true},
      },
      // {
      //   path: '/bills/palnDetails',
      //   name: 'palnDetails',
      //   component: () => import('@/view/bills/billsCP/palnDetails.vue'),
      //   meta: {title: '计划明细',keepAlive: false},
      // },
      {
        path: '/bills/orderStock',
        name: 'orderStock',
        component: () => import('@/view/bills/billsCP/orderStock.vue'),
        meta: {title: '客户库存订单',sideBar:false,keepAlive: true},
      },
      {
        path: '/bills/orderCancelStockSummary',
        name: 'orderCancelStockSummary',
        component: () => import('@/view/bills/billsCP/orderCancelStockSummary.vue'),
        meta: {title: '订单取消库存汇总',sideBar:false,keepAlive: true},
      },
      // {
      //   path: '/packingCp/packing',
      //   name: 'packing',
      //   component: () => import('@/view/other/packingCp/packing.vue'),
      //   meta: {title: '装箱单',sideBar:true,keepAlive: true},
      // },
      {
        path: '/product/newPrice',
        name: 'newPrice',
        component: () => import('@/view/product/productCP/newPrice.vue'),
        meta: {title: '销售定价',sideBar:false,keepAlive: true},
      },
      {
        path: '/historicalDelivery',
        name: 'historicalDelivery',
        component: () => import('@/view/other/historicalDelivery/index.vue'),
        meta: {title: '历史出库单',sideBar:false,keepAlive: true},
      },
      {
        path: '/deliveryDetail',
        name: 'deliveryDetail',
        component: () => import('@/view/other/DeliveryDetail/index.vue'),
        meta: {title: '出库单明细',sideBar:false,keepAlive: true},
      },
      {
        path: '/salespersonAmount',
        name: 'salespersonAmount',
        component: () => import('@/view/other/salespersonAmount/salespersonAmount.vue'),
        meta: {title: '销售下达订单金额',sideBar:false,keepAlive: true},
      },
      {
        path: '/purchaseOrder',
        name: 'purchaseOrder',
        component: () => import('@/view/bills/billsCP/purOrderList.vue'),
        meta: {title: '计划采购明细',sideBar:false,keepAlive: true},
      },
      {
        path: '/SHistory/SHistoryCP',
        name: 'SHistoryCP',
        component: () => import('@/view/SHistory/SHistoryCP/SHistory.vue'),
        meta: {title: '销售历史',sideBar:false,keepAlive: true},
      },
      {
        path: '/quotedPrice/quotedHistory',
        name: 'quotedHistory',
        component: () => import('@/view/other/quotedPrice/quotedPriceCP/quotedHistory.vue'),
        meta: {title: '报价历史',sideBar:false,keepAlive: true},
      },
    ],
  },
]

const router = new Router({
	// mode: 'history',
	base: process.env.BASE_URL,
  routes:company_id==1?routes:routes2
})
// 解决 Vue 重复点击相同路由报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js